import { useRef, useEffect } from 'react';
import { UiConfigType, embedDashboard } from '@superset-ui/embedded-sdk';

import { Box, BoxProps } from '@mui/material';

import { useSupersetContext } from '../../providers/superset';

type SupersetDashboardProps = BoxProps & {
  dashboardId: string;
  config?: UiConfigType;
};

export function SupersetDashboard({
  dashboardId,
  config,
  sx,
  ...boxProps
}: SupersetDashboardProps) {
  const { supersetDomain, fetchGuestToken, defaultConfig } = useSupersetContext();
  const dashboardRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (dashboardRef.current) {
      embedDashboard({
        id: dashboardId,
        supersetDomain,
        mountPoint: dashboardRef.current,
        fetchGuestToken: () => fetchGuestToken(dashboardId),
        dashboardUiConfig: {
          ...defaultConfig,
          ...config,
        },
        iframeSandboxExtras: ['allow-top-navigation', 'allow-popups-to-escape-sandbox'],
        referrerPolicy: 'same-origin',
      });
    }
  }, [config, dashboardId, defaultConfig, fetchGuestToken, supersetDomain]);

  return (
    <Box
      sx={{
        '& iframe': {
          width: '100%',
          height: '100%',
          border: 'none',
        },
        ...sx,
      }}
      {...boxProps}
      component="div"
      ref={dashboardRef}
    />
  );
}
